import GenericBody from "../Componentes/GenericBody";
import NavBar from "../Componentes/NavBar";
import { useModal } from "../contexts/ModalContext";
import Content from "../Modulos/Desvios/Home/Content";

const Desvios = () => {

    const { openModal } = useModal();

    const abrirMenuLateral = () => {
        openModal("sidebarDesvios")
    }

    return(
        <>
            <NavBar title="DESVIOS" goBackOnePage setSideBar={ abrirMenuLateral } />
            <GenericBody>
                <Content />
            </GenericBody>
        </>
    )
}

export default Desvios;